/*
 * Funnel Hero — Opt-in form connected to Klaviyo Client Subscriptions API.
 * Endpoint: https://a.klaviyo.com/client/subscriptions/?company_id={publicKey}
 */
(function () {
  var KLAVIYO_REVISION = '2026-04-15';
  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var SUBMIT_TIMEOUT_MS = 10000;

  function isValidEmail(s) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(s || '').trim());
  }

  function init(root) {
    if (root.__funnelHeroInit) return;
    root.__funnelHeroInit = true;

    var configEl = document.getElementById(root.dataset.configId);
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      console.error('[funnel-hero] invalid config JSON', e);
      return;
    }

    var form = root.querySelector('[data-funnel-form]');
    var nameInput = root.querySelector('[data-funnel-name]');
    var emailInput = root.querySelector('[data-funnel-email]');
    var submitBtn = root.querySelector('[data-funnel-submit]');
    var errorEl = root.querySelector('[data-funnel-error]');
    if (!form || !emailInput || !submitBtn) return;

    var submitting = false;
    var abortController = null;

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.classList.add('is-visible');
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.classList.remove('is-visible');
    }

    function setLoading(state) {
      submitting = state;
      submitBtn.disabled = state;
      submitBtn.classList.toggle('is-loading', state);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitting) return;
      clearError();

      var email = (emailInput.value || '').trim();
      var name = nameInput ? (nameInput.value || '').trim() : '';

      if (config.showName && !name) {
        showError(config.messages.missingName);
        if (nameInput) nameInput.classList.add('is-error');
        return;
      }
      if (nameInput) nameInput.classList.remove('is-error');

      if (!isValidEmail(email)) {
        showError(config.messages.invalidEmail);
        emailInput.classList.add('is-error');
        return;
      }
      emailInput.classList.remove('is-error');

      var k = config.klaviyo || {};
      if (!k.publicKey || !k.listId) {
        showError(config.messages.configMissing);
        console.error('[funnel-hero] Klaviyo public key or list id missing');
        return;
      }

      setLoading(true);
      submitToKlaviyo(k, email, name, 0)
        .then(function (result) {
          setLoading(false);
          if (result.ok) {
            onSuccess();
          } else {
            var msg = config.messages.serverError;
            if (result.error === 'rate_limited') msg = config.messages.rateLimited;
            showError(msg);
          }
        })
        .catch(function (err) {
          console.error('[funnel-hero] submit error', err);
          setLoading(false);
          showError(config.messages.serverError);
        });
    });

    function onSuccess() {
      showSuccess();
      var redirect = (config.redirectUrl || '').trim();
      if (redirect) {
        setTimeout(function () {
          window.location.href = redirect;
        }, 600);
      }
    }

    function showSuccess() {
      if (errorEl) {
        errorEl.textContent = config.messages.success;
        errorEl.classList.add('is-visible');
        errorEl.style.background = 'rgba(125, 147, 137, 0.92)';
        errorEl.style.color = '#fff';
      }
      submitBtn.disabled = true;
    }

    function submitToKlaviyo(k, email, name, retryCount) {
      var url = KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(k.publicKey);

      var profileAttrs = { email: email };
      if (name) {
        var parts = name.split(/\s+/);
        profileAttrs.first_name = parts.shift();
        if (parts.length) profileAttrs.last_name = parts.join(' ');
      }
      profileAttrs.subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };

      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: config.customSource || 'Funnel Hero',
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttrs
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: k.listId } }
          }
        }
      };

      abortController = new AbortController();
      var timeoutId = setTimeout(function () {
        if (abortController) try { abortController.abort(); } catch (e) {}
      }, SUBMIT_TIMEOUT_MS);

      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Revision': KLAVIYO_REVISION
        },
        body: JSON.stringify(body),
        signal: abortController.signal
      })
        .then(function (res) {
          clearTimeout(timeoutId);
          if (res.status === 202) return { ok: true };
          if (res.status === 429) {
            if (retryCount < 2) {
              return new Promise(function (resolve) {
                setTimeout(function () {
                  resolve(submitToKlaviyo(k, email, name, retryCount + 1));
                }, 1500 * Math.pow(2, retryCount));
              });
            }
            return { ok: false, error: 'rate_limited' };
          }
          if (res.status >= 500) {
            console.error('[funnel-hero] Klaviyo server error', res.status);
            if (retryCount < 1) {
              return new Promise(function (resolve) {
                setTimeout(function () {
                  resolve(submitToKlaviyo(k, email, name, retryCount + 1));
                }, 1000);
              });
            }
            return { ok: false, error: 'server' };
          }
          return res.json().then(function (json) {
            var detail = json && json.errors && json.errors[0] && json.errors[0].detail;
            console.error('[funnel-hero] Klaviyo error', res.status, detail || '(no detail)', json);
            return { ok: false, error: detail || 'client_error', status: res.status };
          }).catch(function () {
            console.error('[funnel-hero] Klaviyo response unparseable', res.status);
            return { ok: false, error: 'client_error', status: res.status };
          });
        })
        .catch(function (err) {
          clearTimeout(timeoutId);
          if (err && err.name === 'AbortError') return { ok: false, error: 'timeout' };
          if (retryCount < 1) {
            return new Promise(function (resolve) {
              setTimeout(function () {
                resolve(submitToKlaviyo(k, email, name, retryCount + 1));
              }, 1000);
            });
          }
          return { ok: false, error: 'network' };
        });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-funnel-hero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    var nodes = e.target.querySelectorAll('[data-funnel-hero]');
    nodes.forEach(init);
  });
})();

/* Flip-clock countdown timer */
(function () {
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function setNum(root, key, value) {
    var el = root.querySelector('[data-timer-' + key + ']');
    if (!el) return;
    if (el.textContent !== value) {
      el.textContent = value;
      el.classList.remove('is-flipping');
      void el.offsetWidth;
      el.classList.add('is-flipping');
    }
  }

  function update(root) {
    var endStr = root.getAttribute('data-end');
    if (!endStr) return;
    var endTime = new Date(endStr).getTime();
    if (isNaN(endTime)) return;
    var diff = Math.max(0, endTime - Date.now());
    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var mins = Math.floor((diff % 3600000) / 60000);
    var secs = Math.floor((diff % 60000) / 1000);
    setNum(root, 'days', pad(days));
    setNum(root, 'hours', pad(hours));
    setNum(root, 'minutes', pad(mins));
    setNum(root, 'seconds', pad(secs));
  }

  function tickAll() {
    document.querySelectorAll('[data-funnel-timer]').forEach(update);
  }

  function start() {
    tickAll();
    setInterval(tickAll, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', tickAll);
})();
